import { useId } from 'react'
import { Area, AreaChart, CartesianGrid, ResponsiveContainer, Tooltip, XAxis, YAxis } from 'recharts'
import { shortDate } from '../utils'

export interface ChartPoint {
  date: string
  value: number | null
}

interface TrendChartProps {
  data: ChartPoint[]
  valueFormatter: (value: number) => string
  valueLabel?: string
  ariaLabel: string
}

export function TrendChart({ data, valueFormatter, valueLabel = '数值', ariaLabel }: TrendChartProps) {
  const gradientId = useId().replace(/:/g, '')
  return (
    <div className="trend-chart" role="img" aria-label={ariaLabel}>
      <ResponsiveContainer width="100%" height="100%">
        <AreaChart data={data} margin={{ top: 14, right: 18, bottom: 0, left: 6 }}>
          <defs>
            <linearGradient id={gradientId} x1="0" y1="0" x2="0" y2="1">
              <stop offset="0%" stopColor="#3b82f6" stopOpacity={0.2} />
              <stop offset="100%" stopColor="#3b82f6" stopOpacity={0.015} />
            </linearGradient>
          </defs>
          <CartesianGrid stroke="#e6ecf4" vertical={false} />
          <XAxis dataKey="date" tickFormatter={shortDate} minTickGap={28} tick={{ fill: '#667085', fontSize: 11 }} axisLine={{ stroke: '#dde4ee' }} tickLine={false} />
          <YAxis width={62} tickFormatter={(value) => valueFormatter(Number(value))} tick={{ fill: '#667085', fontSize: 11 }} axisLine={false} tickLine={false} />
          <Tooltip
            labelFormatter={(label) => String(label)}
            formatter={(value) => [value == null ? '—' : valueFormatter(Number(value)), valueLabel]}
            contentStyle={{ border: '1px solid #dde4ee', borderRadius: 4, boxShadow: '0 8px 24px rgba(16,24,40,.12)' }}
          />
          <Area
            type="monotone"
            dataKey="value"
            stroke="#3b82f6"
            strokeWidth={2}
            connectNulls={false}
            fill={`url(#${gradientId})`}
            dot={data.length === 1 ? { r: 4, fill: '#0f66f5', stroke: '#fff', strokeWidth: 2 } : false}
            activeDot={{ r: 4, fill: '#0f66f5', stroke: '#fff', strokeWidth: 2 }}
            isAnimationActive={false}
          />
        </AreaChart>
      </ResponsiveContainer>
    </div>
  )
}
